// ======= plugin import ======== //
import React,{useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Drawer } from "antd";
import { Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage, useFormikContext  } from 'formik';
import axios from 'axios';

import { toast } from 'react-toastify';

// ========= component import =========== //
import HeaderStyle from '../style/LandingHeaderStyle.module.css';
import ButtonLoader from '../../../../app/component/common/ButtonLoader';
import ValidationMessage from '../../../../app/component/common/ValidationMessage';
import { ValidateEmail } from '../../../../app/component/common/Helper';

const LandingHeader = () => {
    const api_base_url = process.env.REACT_APP_API_URL;

    // ============== define all state =========== //
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

    const [demoBookingFormData, setDemoBookingFormData] = useState({
        book_inp_name: '',
        book_inp_email: '',
        book_inp_phone: '',
        book_inp_landline: '',
        book_inp_organization: '',
        book_purpose: [],
        your_messages: '',
        book_channel: [],
        book_volume: '',
        book_crm: '',
        book_terms_and_conditions: false
    });
    const [demoBookingFormError, setDemoBookingFormError] = useState({});
    const [ submitButtonLoader, setSubmitButtonLoader ] = useState(false)

    // ================= end state ============= //

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    const menuDrawerOnClose = () => {
        setMobileMenuIsOpen(false)
    }
    const mobileMenuIsOpenOnClick = () => {
        setMobileMenuIsOpen(true)
    }

    const validateField = (name, value) => {
        let error = "";
        if (name === "book_inp_name") {
            if (!value) {
                error = "Name is required";
            } 
        }

        if(name === 'book_inp_email'){
            if (!value) {
                error = "Email is required";
            }
            else if (!ValidateEmail(value)) {
                error = "Invalid email address";
            }
        }
        if(name === 'book_inp_phone'){
            if (!value) {
                error = "Phone no is required";
            }
        }

        if(name === 'book_inp_organization'){
            if (!value) {
                error = "Organization is required";
            }
        }

        if(name === 'your_messages'){
            if (!value) {
                error = "Messages is required";
            }
        }

        if(name === 'book_terms_and_conditions'){
            if (!value) {
                error = "Terms and Conditions is required.";
            }
        }

        return error;
    }

    const inputChangeHandler = (selectedOption, actionMeta) => {
        if(selectedOption?.target){
            // ----- for input ----- //
            const { name, value, type, checked  } = selectedOption.target;
            let fieldValue;
            if(type === 'checkbox'){
                if(name === 'book_terms_and_conditions'){
                    fieldValue = checked
                }
                else if(name === 'book_purpose'){
                    fieldValue = [...demoBookingFormData.book_purpose];
                    if (checked) {
                        if (!fieldValue.includes(value)) {
                            fieldValue.push(value);
                        }
                    }
                    else{
                        fieldValue = fieldValue.filter((item) => item !== value);
                    }
                }
                else if(name === 'book_channel'){
                    fieldValue = [...demoBookingFormData.book_channel];
                    if (checked) {
                        if (!fieldValue.includes(value)) {
                            fieldValue.push(value);
                        }
                    }
                    else{
                        fieldValue = fieldValue.filter((item) => item !== value);
                    }
                }
            }
            else{
                if (name === 'book_inp_phone' || name === 'book_inp_landline'){
                    fieldValue = value.replace(/\D/g, '');
                } else {
                    fieldValue = value;
                }
            }
            const fieldError = validateField(name, fieldValue);
            setDemoBookingFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setDemoBookingFormData((prevData) => ({
                ...prevData,
                [name]: fieldValue,
            }));
        }
    };

    const formSubmitHandler = async (e) => {
        e.preventDefault();

        const newErrors = {};

        for (const key in demoBookingFormData) {
            newErrors[key] = validateField(key, demoBookingFormData[key]);
        }
        setDemoBookingFormError(newErrors);

        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setSubmitButtonLoader(true);

            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            try{
                await axios.post(`${api_base_url}api/save-booking-info`, demoBookingFormData, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        toast.success(res.data.message);
                    } else if(res.data.status === 'error') {
                        toast.error(res.data.message);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
            }
            catch(e){
                console.error(e);
            }
            finally{
                setDemoBookingFormData({
                    book_inp_name: '',
                    book_inp_email: '',
                    book_inp_phone: '',
                    book_inp_landline: '',
                    book_inp_organization: '',
                    book_purpose: [],
                    your_messages: '',
                    book_channel: [],
                    book_volume: '',
                    book_crm: '',
                    book_terms_and_conditions: false
                });
                setDemoBookingFormError({})
                setSubmitButtonLoader(false)
            }
        }
    }

    const formResetOnClick = () => {
        setDemoBookingFormData({
            book_inp_name: '',
            book_inp_email: '',
            book_inp_phone: '',
            book_inp_landline: '',
            book_inp_organization: '',
            book_purpose: [],
            your_messages: '',
            book_channel: [],
            book_volume: '',
            book_crm: '',
            book_terms_and_conditions: false
        });
        setDemoBookingFormError({})
    }
  
    return (
        <>
            {/* <ToastContainer/> */}
            <style>
                {
                    `
                        .video-modal{
                            background-color:#0000005c;
                        }
                        .video-modal .cursor-pointer{
                            position:absolute;
                            background:#fff;
                            padding:12px 15px;
                            border-radius:50%;
                            margin:14px;
                            right:15px;
                        }
                        input[type="checkbox"] {
                            background-color: white;
                        }
                        @media (max-width:575px){
                            .m-gap {
                                gap:5px !important;
                            }
                        }
                    `
                }
            </style>
            <header className={`header-area style-1 pos-abs zi-9 ${scrolled ? HeaderStyle.headerScrolled : ''}`}>
                <div className="container">
                    <div className="header-area__inner">
                        <div className="header__logo">
                            <Link to="/">
                                <img src="/truvoice_logo-new.png" className={`normal-logo ${HeaderStyle.headerLogo}`} alt="Site Logo" />
                            </Link>
                        </div>
                        <div className={`header__nav pos-center ${HeaderStyle.navLinks}`}>
                            <nav className="main-menu">
                                <ul>
                                    <li className="menu-item-has-children">
                                        <Link to="#">Products</Link>
                                        <ul className="dp-menu">
                                            <li>
                                                <Link to="/truvoice-platform">
                                                    TruVoice AI Platform
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/fully-managed">
                                                    Fully-managed Agents
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    TruChat Widget
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    TruLive Chat
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <Link to="#">Services</Link>
                                        <ul className="dp-menu">
                                            <li>
                                                <Link to="/custom-built">
                                                    Custom-built Agents
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/language-models">
                                                    Language Models
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/ai-ml-services">
                                                    AI/ML Services
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    Application Development
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <Link to="#">Pre-built AI Agents</Link>
                                        
                                    </li>
                                    {/* <li className="menu-item-has-children">
                                        <Link to="#">Pricing</Link>
                                        <ul className="dp-menu">
                                            <li>
                                                <Link to="#">
                                                    Platform Pricing
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    Fully Managed Pricing
                                                </Link>
                                            </li>
                                        </ul>
                                    </li> */}
                                    <li><Link to="/resource">Resources</Link></li>
                                </ul>
                            </nav>
                        </div>
                        <div className={`header__button ${HeaderStyle.requestDemoBtn}`}>
                            <button 
                                className="wc-btn wc-btn-primary btn-text-flip p-5"
                                data-bs-toggle="modal"
                                data-bs-target="#book_demo_modal"
                            > 
                                <span data-text="Request Demo" className="fs-4">Request Demo</span>
                            </button>
                        </div>
                        <div className={`header__button ${HeaderStyle.menuIcon}`}>
                            <FontAwesomeIcon icon={faBars} className='text-gray-700 fs-2x' onClick={mobileMenuIsOpenOnClick}/>
                        </div>
                    </div>
                </div>
            </header>
            {/* ============ mobile menu drawer ========== */}
            <Drawer
                width={300}
                open={mobileMenuIsOpen}
                placement={'left'}
                closable={false}
                maskClosable={true}
                onClose={menuDrawerOnClose}
                styles={{ body: { overflowX: "hidden" } }}
            >
                <div className="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0">
                    <div className='ms-5 mb-8'>
                        <img alt='Logo' src='/truvoice_logo-new.png' className='h-30px' />
                    </div>
                    <div className="menu-item here p-3">
                        <span className="menu-link">
                            <span className="menu-title fs-5">Products</span>
                        </span>
                    </div>
                    <div className="menu-item p-3">
                        <span className="menu-link">
                            <span className="menu-title fs-5">Services</span>
                        </span>
                    </div>
                    <div className="menu-item p-3">
                        <span className="menu-link">
                            <span className="menu-title fs-5">Pre-built Models</span>
                        </span>
                    </div>
                    <div className="menu-item p-3">
                        <span className="menu-link">
                            <span className="menu-title fs-5">Pricing</span>
                        </span>
                    </div>
                    <div className="menu-item p-3">
                        <span className="menu-link">
                            <span className="menu-title fs-5">Resources</span>
                        </span>
                    </div>


                    {/* <div className="offcanvas-area-menu-wrapper">
                        <ul id="accordion" className="accordion">
                            <li className="">
                            <div className="link">Home <img className="angle-down" src="assets/imgs/icon/angle-down.png" alt="icon image" />
                            </div>
                            <ul className="submenu">
                                <li><a href="ai-content-writer.html">AI Content Writer</a></li>
                                <li><a href="ai-image-generator.html">AI Image Generator</a></li>
                                <li><a href="ai-chatbot.html" className="active-page">AI Chatbot</a></li>
                                <li><a href="ai-seo.html">AI SEO Software</a></li>
                                <li><a href="ai-software.html">AI Startups</a></li>
                                <li><a href="ai-video-editor.html">AI Video Editor</a></li>
                                <li><a href="booking.html">Booking Software</a></li>
                                <li><a href="online-meeting.html">Virtual Meeting</a></li>
                                <li><a href="crm.html">CRM Software</a></li>
                                <li><a href="customer-service.html">Customer Support</a></li>
                                <li><a href="mobile-apps.html">Mobile App / SASS</a></li>
                                <li><a href="marketing-automation.html">Marketing automation</a></li>
                            </ul>
                            </li>
                            <li>
                            </li><li><a href="about.html">About</a></li>
                            <li>
                            <div className="link">Pages<img className="angle-down" src="assets/imgs/icon/angle-down.png" alt="icon image" /></div>
                            <ul className="submenu">
                                <li><a href="integration.html">integration</a></li>
                                <li><a href="integration-single.html">integration single</a></li>
                                <li><a href="about.html">about</a></li>
                                <li><a href="contact.html">contact</a></li>
                                <li><a href="404.html">404</a></li>
                                <li><a href="pricing.html">pricing</a></li>
                                <li><a href="faq.html">faq</a></li>
                                <li><a href="all-template.html">video templete</a></li>
                                <li><a href="team.html">team page</a></li>
                                <li><a href="privacy-policy.html">privacy policy</a></li>
                            </ul>
                            </li>
                            <li><a href="pricing.html">Pricing</a></li>
                            <li><a href="team.html">Team</a></li>
                            <li><a href="faq.html">FaQ</a></li>
                            <li>
                            <div className="link">Blog<img className="angle-down" src="assets/imgs/icon/angle-down.png" alt="icon image" /></div>
                            <ul className="submenu">
                                <li><a href="blog.html">Our Blog</a></li>
                                <li><a href="blog-details.html">Blog Details</a></li>
                            </ul>
                            </li>
                        </ul>
                    </div> */}


                    <button className="btn wc-btn wc-btn-primary round-btn fs-5 mx-5 p-5 mt-5" data-bs-toggle="modal"
                        data-bs-target="#book_demo_modal">
                        Request Demo
                    </button>
                </div>
            </Drawer>
            <div className="modal fade modal-lg video-modal" id="book_demo_modal" data-bs-backdrop="false" data-bs-keyboard="true">
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body p-0 overflow-x-hidden">
                            <div className='row border p-10 custom-card-bg br-20'>
                                <div className='col-md-12'>
                                    <div className='text-center'>
                                        <h2 className="section-title fs-2hx text-grad-3">
                                            Book Your Free Demo
                                        </h2>
                                        <p className="text my-3 pe-5 fs-3 text-gray-700">
                                            Discover how our solution can work for you—schedule a personalized walkthrough
                                        </p>
                                    </div>
                                    <form onSubmit={formSubmitHandler} autoComplete="off">
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_inp_name" 
                                                        placeholder="Name" 
                                                        autoComplete="new-password" 
                                                        name="book_inp_name"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_name}
                                                    />
                                                    <label htmlFor="book_inp_name" className='fs-4'>Name</label>
                                                    {
                                                        demoBookingFormError.book_inp_name && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_inp_name}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_inp_email" 
                                                        placeholder="Email" 
                                                        autoComplete="new-password" 
                                                        name="book_inp_email"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_email}
                                                    />
                                                    <label htmlFor="book_inp_email" className='fs-4'>Email</label>
                                                    {
                                                        demoBookingFormError.book_inp_email && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_inp_email}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_inp_phone" 
                                                        placeholder="Phone" 
                                                        autoComplete="new-password" 
                                                        name="book_inp_phone"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_phone}
                                                    />
                                                    <label htmlFor="book_inp_phone" className='fs-4'>Phone</label>
                                                    {
                                                        demoBookingFormError.book_inp_phone && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_inp_phone}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_inp_landline" 
                                                        placeholder="Landline" 
                                                        autoComplete="new-password"
                                                        name="book_inp_landline" 
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_landline}
                                                    />
                                                    <label htmlFor="book_inp_landline" className='fs-4'>Landline</label>
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className="form-floating mb-5">
                                                    <input 
                                                        type="text"
                                                        className="form-control" 
                                                        id="book_inp_organization" 
                                                        placeholder="Organization" 
                                                        autoComplete="new-password"
                                                        name="book_inp_organization"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_inp_organization}
                                                    />
                                                    <label htmlFor="book_inp_organization" className='fs-4'>
                                                        Organization
                                                    </label>
                                                    {
                                                        demoBookingFormError.book_inp_organization && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_inp_organization}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-12 mb-5'>
                                                <div className='row border border-primary border-dashed p-4 rounded m-auto m-gap'>
                                                    <div className='col-md-4'>
                                                        <div className="form-check">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Sales" 
                                                                id="sales"
                                                                name="book_purpose"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_purpose?.includes("Sales") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="sales">
                                                                Sales
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Services" 
                                                                id="services"
                                                                name="book_purpose"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_purpose?.includes("Services") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="services">
                                                                Services
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Others" 
                                                                id="others"
                                                                name="book_purpose"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_purpose?.includes("Others") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="others">
                                                                Others
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-12 mb-5'>
                                                <div className="form-floating">
                                                    <textarea
                                                        as="textarea"
                                                        className="form-control" 
                                                        placeholder="How can we help you?" 
                                                        id="your_messages"
                                                        name="your_messages"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.your_messages}
                                                    ></textarea>
                                                    <label htmlFor="your_messages" className='fs-4'>
                                                        How can we help you?
                                                    </label>
                                                    {
                                                        demoBookingFormError.your_messages && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.your_messages}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-12 mb-5'>
                                                <div className='row border border-primary border-dashed p-4 rounded m-auto m-gap'>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Web" 
                                                                id="ch_web"
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Web") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_web">
                                                                Web
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Facebook" 
                                                                id="ch_facebook" 
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Facebook") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_facebook">
                                                                Facebook
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="WhatsApp" 
                                                                id="cd_whatsapp"
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("WhatsApp") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="cd_whatsapp">
                                                                WhatsApp
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Mobile" 
                                                                id="ch_mobile"
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Mobile") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_mobile">
                                                                Mobile
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Telegram" 
                                                                id="ch_telegram"
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Telegram") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_telegram">
                                                                Telegram
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-check ">
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                value="Others" 
                                                                id="ch_others" 
                                                                name="book_channel"
                                                                onChange={inputChangeHandler}
                                                                checked={demoBookingFormData.book_channel?.includes("Others") || false}
                                                            />
                                                            <label className="form-check-label mt-1 text-gray-700" htmlFor="ch_others">
                                                                Others
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <input 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_volume" 
                                                        placeholder="Volume of interaction expected in a month" autoComplete="new-password"
                                                        name="book_volume"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_volume}
                                                    />
                                                    <label htmlFor="book_volume" className='fs-4'>Volume of interaction expected in a month</label>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <input
                                                        type="text" 
                                                        className="form-control" 
                                                        id="book_crm" 
                                                        placeholder="Name of CRM" 
                                                        autoComplete="new-password"
                                                        name="book_crm"
                                                        onChange={inputChangeHandler}
                                                        value={demoBookingFormData.book_crm}
                                                    />
                                                    <label htmlFor="book_crm" className='fs-4'>Name of CRM</label>
                                                </div>
                                            </div>
                                            <div className='col-md-12 mt-2'>
                                                <div className="form-check form-check-solid mt-3">
                                                    <input 
                                                        className="form-check-input bg-dark" 
                                                        type="checkbox" 
                                                        value="" 
                                                        id="flexCheckDefault" 
                                                        name="book_terms_and_conditions"
                                                        onChange={inputChangeHandler}
                                                        checked={demoBookingFormData.book_terms_and_conditions}
                                                    />
                                                    <label className="form-check-label mt-1 text-gray-700" htmlFor="flexCheckDefault">
                                                        I agree to TruVoice's Terms & Conditions of Use and Privacy Policy.
                                                    </label>
                                                    {
                                                        demoBookingFormError.book_terms_and_conditions && 
                                                        <ValidationMessage className='text-danger mt-2' message ={demoBookingFormError.book_terms_and_conditions}/>
                                                    }
                                                </div>
                                            </div>
                                            <div className='col-md-12 text-end mt-2'>
                                                <button 
                                                    className="btn btn-outline btn-outline-dark btn-active-light-dark me-2"
                                                    data-bs-dismiss="modal"
                                                    onClick={formResetOnClick}
                                                    type="button"
                                                >
                                                    Close
                                                </button>
                                                <button className={`btn btn-dark ${submitButtonLoader && 'disabled'}`} type="submit">
                                                    {
                                                        submitButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Submit'
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default LandingHeader